import {  Crud_Catalogos } from "../../herramientas/Crud_Catalogos";
import { timeToDateNumbers, timeToYearmonthDay } from "../../herramientas/DateFormat";
import { NotificationManager } from "react-notifications";

export async function Arroba(idPlataforma, mov, acumulador, etiqueta, imagen, nota){
    let enviaWhastApp= false;
    /*
    let formData = new FormData();
    if(imagen){        
        formData.append("imagen",imagen);
    }*/
   if(imagen){
        let imagenTemp= new File([imagen], 1+"_"+mov.idPlataforma.id+"_"+mov.id+"_"+timeToDateNumbers(new Date().getTime())+"."+imagen.name.split('.').pop(), {//original.name | acumulador_idPlataforma_movimiento
            type: imagen.type,
            lastModified: imagen.lastModified,
        });       
        await cargar_imagen_por_acumulador_mail(imagenTemp);
    }
    /*
    Crud_Catalogos("whatsapp_configuracion/plataforma/"+idPlataforma, "whatsapp_configuracion", "get", "").then((returnVal) => {
        if( returnVal.id ){
            //Crud_Catalogos("whatsapp_mensajes/naviero?acumulador=3&id_plt="+idPlataforma+"&id_mov="+movimiento, "movimientos", "post", "").then((returnVal) => {
            Crud_Catalogos("whatsapp/v2/enviar_mensajes?id_plt="+idPlataforma+"&id_mov="+mov.id+"&acumulador="+acumulador+"&etiqueta="+etiqueta, "movimientos", "post", "").then((returnVal) => {
                NotificationManager.info(
                    "Notificación de whatsApp enviada, mov: "+ mov.id, "Notificación"
                  );
            }).catch(err =>{ console.log("error: "+err);});
        }
    }).catch(err =>{ console.log("error: "+err);});
        
    return Crud_Catalogos("mail/arrobanaviera/"+mov.id+"/"+acumulador+"?nota="+nota, "movimientos", "post", "", null).then((returnVal) => {
        //console.log("respuesta: ",returnVal);
        return returnVal;
    }).catch(err =>{
        console.log("error: "+err);
        return "Error desconocido ....";
    });
    */
   //http://localhost:8000/notificaciones/enviar?id_plt=61&id_mov=100496&acumulador=3&etiqueta=1&envia_correo=true&envia_whastApp=true
   await Crud_Catalogos("whatsapp_configuracion/plataforma/"+idPlataforma, "whatsapp_configuracion", "get", "").then((returnVal) => {
        if( returnVal.id ){
            enviaWhastApp= true;
        }
    }).catch(err =>{ console.log("error: "+err);});
   return Crud_Catalogos(
    "notificaciones/enviar?id_plt="+mov.idPlataforma.id+"&id_mov="+mov.id+"&acumulador="+acumulador+"&etiqueta="+etiqueta+"&envia_correo=true&envia_whastApp="+enviaWhastApp
    , "movimientos", "post", "", null).then((returnVal) => {
        //console.log("respuesta: ",returnVal);
        return returnVal.message;
    }).catch(err =>{
        console.log("error: "+err);
        return "Error desconocido ....";
    });
}

/**
 * Envia 2 mov en una solo notificacion
 * @param {*} idPlataforma 
 * @param {*} movimientos 
 * @param {*} acumulador 
 * @param {*} imagen 
 * @param {*} nota 
 * @returns 
 */
export async function ArrobaFull(idPlataforma, movs, acumulador, etiqueta, imagen, nota){//188515 //1274430, 478312
    /*
    let formData = new FormData();
    if(imagen){        
        formData.append("imagen",imagen);
    }*/
   let ids=[];
   for(let mov of movs){
        ids.push(mov.id);
        if(imagen){
            let imagenTemp= new File([imagen], 1+"_"+mov.idPlataforma.id+"_"+mov.id+"_"+timeToDateNumbers(new Date().getTime())+"."+imagen.name.split('.').pop(), {//original.name | acumulador_idPlataforma_movimiento
                type: imagen.type,
                lastModified: imagen.lastModified,
            });       
            await cargar_imagen_por_acumulador_mail(imagenTemp);
        }
    }
    Crud_Catalogos("whatsapp_configuracion/plataforma/"+idPlataforma, "whatsapp_configuracion", "get", "").then((returnVal) => {
        if( returnVal.id ){
            for(let m of movs){
                Crud_Catalogos("whatsapp/v2/enviar_mensajes?id_plt="+idPlataforma+"&id_mov="+m.id+"&acumulador="+acumulador+"&etiqueta="+etiqueta, "movimientos", "post", "").then((returnVal) => {
                    NotificationManager.info(
                        "Notificación de whatsApp enviada, mov: "+ m.id, "Notificación"
                        );
                }).catch(err =>{ console.log("error: "+err);});
            }
        }
    }).catch(err =>{ console.log("error: "+err);});
    
        
    return Crud_Catalogos("mail/arrobanaviera_full/"+ids+"/"+acumulador+"?nota="+nota, "movimientos", "post", "", null).then((returnVal) => {
        return returnVal;
    }).catch(err =>{
        console.log("error: "+err);
        return "Error desconocido ....";
    });
}

export function ArrobaTerrestre(idmovmiento, acumulador){
    return Crud_Catalogos("mail/arrobaterrestre/"+idmovmiento+"/"+acumulador, "movimientos", "get", "").then((returnVal) => {
        return returnVal;
        }).catch(err =>{
        if( err.response ){
            console.log(err.response);
            return err.response;
        }else{
            return "Error desconocido ....";
        }
    })
}
export async function ArrobaIncidencia(idPlataforma, mov, id, imagenes, etiqueta){
    let enviaWhastApp= false;
    //let formData = new FormData();
    /*
    if(imagen){
        let imagenTemp= new File([imagen], 1+"_"+idPlataforma+"_"+movimiento+"_"+timeToDateNumbers(new Date().getTime())+"."+imagen.name.split('.').pop(), {//original.name | acumulador_idPlataforma_movimiento
            type: imagen.type,
            lastModified: imagen.lastModified,
        });        
        await cargar_imagen_por_acumulador(imagenTemp);
        formData.append("imagen", imagen);
    }*/
   if(imagenes.length){
        for( let imagen of imagenes ){
            let imagenTemp= new File([imagen], 1+"_"+idPlataforma+"_"+mov.id+"_"+id+"_"+timeToDateNumbers(new Date().getTime())+"."+imagen.name.split('.').pop(), {//original.name | acumulador_idPlataforma_movimiento
                type: imagen.type,
                lastModified: imagen.lastModified,
            });      
            await cargar_imagen_por_acumulador(imagenTemp);
        }
    }
    if(imagenes.length){
        for( let imagen of imagenes ){
            let imagenTemp= new File([imagen], 1+"_"+mov.idPlataforma.id+"_"+mov.id+"_"+id+"_"+timeToDateNumbers(new Date().getTime())+"."+imagen.name.split('.').pop(), {//original.name | acumulador_idPlataforma_movimiento
                type: imagen.type,
                lastModified: imagen.lastModified,
            });       
            await cargar_imagen_por_acumulador_mail(imagenTemp);
        }
    }
    await Crud_Catalogos("whatsapp_configuracion/plataforma/"+idPlataforma, "whatsapp_configuracion", "get", "").then((returnVal) => {
        if( returnVal.id ){
            enviaWhastApp= true;
        }
    }).catch(err =>{ console.log("error: "+err);});
    /*
    @PostMapping("/enviar")
    //@PreAuthorize("hasAuthority('plataformas_tipo_agregar')")
    public RespuestaGenerica enviarMensaje(
            @RequestParam(value = "id_plt", required = true) Integer idPlataforma,
            @RequestParam(value = "id_mov", required = true) Integer idMovimiento,
            @RequestParam(value = "acumulador", required = true) Integer acumulador,
            @RequestParam(value = "etiqueta", required = true) Integer etiqueta,
            @RequestParam(value = "id_alerta", required = false) Integer idAlerta,//al paracer el campo idAlerta se enviaria solo por backend 
            @RequestParam(value = "id_incidencia", required = false) Integer idIncidencia,
            @RequestParam(value = "envia_correo", required = false) boolean enviaCorreo,
            @RequestParam(value = "envia_whastApp", required = false) boolean enviawhastApp,
            HttpServletRequest req, HttpServletResponse res
            ) {
    */
   /*
    return Crud_Catalogos(
        "notificaciones/enviar?id_plt="+mov.idPlataforma.id+"&id_mov="+mov.id+"&id_incidencia="+id+"&acumulador=1&etiqueta="+etiqueta+"&envia_correo=true&envia_whastApp="+enviaWhastApp
        , "movimientos", "post", "", null).then((returnVal) => {
            //console.log("respuesta: ",returnVal);
            return returnVal.message;
        }).catch(err =>{
            console.log("error: "+err);
            return "Error desconocido ....";
        });*/
        
    
    await Crud_Catalogos("whatsapp_configuracion/plataforma/"+idPlataforma, "whatsapp_configuracion", "get", "").then((returnVal) => {
        if( returnVal.id ){
            Crud_Catalogos(
              //"whatsapp_mensajes/naviero?acumulador=1&id_plt="+idPlataforma+"&id_mov="+movimiento,
              "whatsapp/v2/enviar_mensajes?id_plt="+idPlataforma+"&id_mov="+mov.id+"&acumulador="+1+"&etiqueta="+etiqueta,
              "movimientos",
              "post",
              "").then((returnVal) => {
                //console.log("respuesta whatsApp: ", returnVal);
            }).catch(err =>{ console.log("error: "+err);});
        }
    }).catch(err =>{ console.log("error: "+err);});

    
    return Crud_Catalogos("mail/arrobanavieraincidencia/"+id, "movimientos", "post", "", null).then((returnVal) => {
        return returnVal;
        }).catch(err =>{
        if( err.response ){
            console.log(err.response);
            return err.response;
        }else{
            return "Error desconocido ....";
        }
    });
}
function cargar_imagen_por_acumulador(imagen){
    let formData = new FormData();
    if(imagen){
        // Validar que sea una imagen
        const isImage = /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(imagen.name);
        if(!isImage) return false;
        
        formData.append("file",imagen);
        return Crud_Catalogos("cargar_imagen_por_acumulador", "cargar_imagen_por_acumulador", "post", "", formData).then((returnVal) => {
            return returnVal;
            }).catch(err =>{ console.log("error: "+err);});
    }else{
        return false;
    }
}
function cargar_imagen_por_acumulador_mail(imagen){
    let formData = new FormData();
    if(imagen){
        // Validar que sea una imagen
        const isImage = /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(imagen.name);
        if(!isImage) return false;
        
        formData.append("file",imagen);
        return Crud_Catalogos("cargar_imagen_por_acumulador_mail", "cargar_imagen_por_acumulador_mail", "post", "", formData).then((returnVal) => {
            return returnVal;
            }).catch(err =>{ console.log("error: "+err);});
    }else{
        return false;
    }
}
export async function ArrobaIncidenciaTerrestre(id, mov,imagenes){/*
    let formData = new FormData();
    if(imagen){
        formData.append("imagen", imagen);
    }*/
    //Guardar imagenes
    if(imagenes.length){
        for( let imagen of imagenes ){
            let imagenTemp= new File([imagen], 1+"_"+mov.plataforma.id+"_"+mov.id+"_"+id+"_"+timeToDateNumbers(new Date().getTime())+"."+imagen.name.split('.').pop(), {//original.name | acumulador_idPlataforma_movimiento
                type: imagen.type,
                lastModified: imagen.lastModified,
            });       
            await cargar_imagen_por_acumulador_mail(imagenTemp);
        }
    }
    await Crud_Catalogos("mail/arrobaterrestreincidencia/"+id, "movimientos", "post", "",  null).then((returnVal) => {
        NotificationManager.info(
            returnVal, "Notificación"
        );
        return returnVal;
    }).catch(err =>{
        if( err.response ){
            console.log(err.response);
            //return err.response;
            NotificationManager.error(
                "Ha ocurrido un error al enviar correo: "+ err.response, "Notificación"
            );
            return err.response;
        }else{
            NotificationManager.error(
                "Error desconocido ....", "Notificación"
            );
            return "Error desconocido ....";
        }
    });
}
export async function WhatsAppIncidenciaTerrestre(idPlataforma, movimiento, id, imagenes, etiqueta){
    if(imagenes.length){
        for( let imagen of imagenes ){
            let imagenTemp= new File([imagen], 1+"_"+idPlataforma+"_"+movimiento+"_"+id+"_"+timeToDateNumbers(new Date().getTime())+"."+imagen.name.split('.').pop(), {//original.name | acumulador_idPlataforma_movimiento
                type: imagen.type,
                lastModified: imagen.lastModified,
            });      
            await cargar_imagen_por_acumulador(imagenTemp);
        }
    }
    
    await Crud_Catalogos("whatsapp_configuracion/plataforma/"+idPlataforma, "whatsapp_configuracion", "get", "").then((returnVal) => {
        if( returnVal.id ){
            Crud_Catalogos(
                //"whatsapp_mensajes/naviero?acumulador=1&id_plt="+idPlataforma+"&id_mov="+movimiento,
                "whatsapp/v2/enviar_mensajes?id_plt="+idPlataforma+"&id_mov="+movimiento+"&acumulador="+1+"&etiqueta="+etiqueta,
                "movimientos",
                "post",
                "").then((returnVal) => {
                NotificationManager.info(
                    (returnVal.message? returnVal.message:""), "Notificación"
                );
                return returnVal;
                //console.log("respuesta whatsApp: ", returnVal);
            }).catch(err =>{
                console.log("error: "+err);
                NotificationManager.error(
                    "Ha ocurrido un error al enviar WhatsApp", "Notificación"
                );
                return "Ha ocurrido un error al enviar WhatsApp";
            });
        }else{
            NotificationManager.warning(
                "No tienes whatsApp configurado enviar WhatsApp", "Notificación"
            );
            return "No tienes whatsApp configurado enviar WhatsApp";
        }
    }).catch(err =>{
        console.log("error: "+err);
        NotificationManager.error(
            "Ha ocurrido un error al obtener configuración WhatsApp", "Notificación"
        );
        return "Ha ocurrido un error al obtener configuración WhatsApp";
    });
}
export function ArrobaIncidenciaTerrestreTraxion(id, imagen){
    let formData = new FormData();
    if(imagen){        
        formData.append("imagen", imagen);
    }
    return Crud_Catalogos("mail/arrobaterrestreincidencia_traxion/"+id, "movimientos", "post", "", formData).then((returnVal) => {
          return returnVal;
        }).catch(err =>{
        if( err.response ){
            console.log(err.response);
            return err.response;
        }else{
            return "Error desconocido ....";
        }
    })
}

export default Arroba;
